import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faSync } from '@fortawesome/free-solid-svg-icons';

const FlashCardComponent = ({ deck = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);

  if (!deck || deck.length === 0) {
    return <div className="has-text-centered has-text-grey-light">No flashcards for this lesson yet.</div>;
  }

  const handleFlip = () => setFlipped(f => !f);
  const handleNext = () => {
    setCurrentIndex(i => (i < deck.length - 1 ? i + 1 : 0));
    setFlipped(false);
  };
  const handlePrev = () => {
    setCurrentIndex(i => (i > 0 ? i - 1 : deck.length - 1));
    setFlipped(false);
  };
  const handleRestart = () => {
    setCurrentIndex(0);
    setFlipped(false);
  };

  const card = deck[currentIndex];

  return (
    <div className="flashcard-outer has-text-centered">
      <div className="flashcard-progress mb-2">
        <span className="tag is-info is-light">{currentIndex + 1} of {deck.length}</span>
        <button className="button is-small is-rounded is-light ml-2" onClick={handleRestart} title="Restart">
          <FontAwesomeIcon icon={faSync} />
        </button>
      </div>
      <div className={`flashcard-card${flipped ? ' flipped' : ''}`} onClick={handleFlip} tabIndex={0} role="button">
        <div className="flashcard-card-inner">
          <div className="flashcard-card-front">
            <div className="is-size-4 has-text-weight-bold mb-2">Question</div>
            <div className="is-size-5">{card.question}</div>
            <div className="flashcard-flip-hint mt-4">Click to reveal answer</div>
          </div>
          <div className="flashcard-card-back">
            <div className="is-size-4 has-text-weight-bold mb-2">Answer</div>
            <div className="is-size-5 has-text-success">{card.answer}</div>
            <div className="flashcard-flip-hint mt-4">Click to go back</div>
          </div>
        </div>
      </div>
      <div className="flashcard-nav mt-4">
        <button className="button is-info is-light is-rounded mr-2" onClick={handlePrev}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
        <button className="button is-info is-light is-rounded" onClick={handleNext}>
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      </div>
    </div>
  );
};

export default FlashCardComponent; 